import { useEffect, useState } from "react";
import towerBridge from '../sketches/tower-bridge.svg';
import recordPlayer from '../sketches/record-player-2.svg';
import gallifrey from '../sketches/gallifrey.svg';
import film from '../sketches/film.svg';
import book from '../sketches/book.svg';

function OurStory() {
  const [story, setStory] = useState(null);

  useEffect(() => {
    fetch('/our-story.json')
      .then((res) => res.json())
      .then((data) => setStory(data))
      .catch((err) => console.error("Failed to load story:", err));
  }, []);

  if (!story) return null;

  return (
    <div className="container">
      <h1 className="tangerine-bold">Our Story</h1>
      <div className="content">
        <p className="josefin-slab">
          {story.paragraphs[0]}
          <img src={towerBridge} className="sketch" alt="Sketch of Tower Bridge" style={{cssFloat:'right',opacity: 0.8,maxHeight: '230px'}} />
          <br/><br/>
          {story.paragraphs[1]}
          <img src={recordPlayer} className="sketch" style={{cssFloat:'left'}} height="240px" alt="Sketch of a record player" />
          <br/><br/>
          {story.paragraphs[2]}
          <br/><br/>
          {story.paragraphs[3]}
          <img src={gallifrey} className="sketch" style={{margin:'auto',padding:'20px'}} height="150px" alt="Sketch of Gallifrey from Doctor Who" />
          {story.paragraphs[4]}
          <img src={film} className="sketch" style={{maxWidth: '50%',cssFloat:'right',marginRight:'-32px'}} alt="Sketch of a film strip" />
          {story.paragraphs[5]}
          <br/><br/>
          {story.paragraphs[6]}
          <br/><br/>
        </p>
        <p className="josefin-slab" style={{textAlign:'center'}}>
          {story.paragraphs[7]}
        </p>
        <img src={book} className="sketch" style={{marginLeft:'auto',marginRight:'auto',width:'225px'}} alt="Sketch of an open book" />
      </div>
    </div>
  )
}

export default OurStory;
